module.exports = __webpack_public_path__ + "img/ACORN-O.ab621b2f.svg";